import { confirmationWord } from './constants';

export const qaRowClassName = ({ memberId }) => `qa_${memberId}`;

export const checkIsConfirmed = text => text.toLowerCase() === confirmationWord;
